<h1 mat-dialog-title>Conferma</h1>
<div mat-dialog-content>
  <p>Sei sicuro di voler rimuovere <strong>{{data}}</strong> dal portafoglio?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()">Si</button>
  <button mat-button (click)="onNoClick()">Cancella</button>
</div>
